import * as React from "react";
import Table from "@material-ui/core/Table/Table";
import TableHead from "@material-ui/core/TableHead/TableHead";
import TableRow from "@material-ui/core/TableRow/TableRow";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableBody from "@material-ui/core/TableBody/TableBody";
import Search from "@material-ui/icons/Search";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import IconButton from "@material-ui/core/IconButton/IconButton";
import FormControl from "@material-ui/core/FormControl/FormControl";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import Input from "@material-ui/core/Input/Input";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import { IAuthContextProps, withAuthContext } from "./with-auth-context";
import { ItemSearchModel } from "../model/autogen/ItemSearchModel";
import { PeopleRequestFactory } from "../model/autogen/PeopleController";
import { ISnackbarContextProps, withSnackbar } from "./with-snackbar";
import Button from "../../node_modules/@material-ui/core/Button/Button";
import { IdNamePair } from "../model/autogen/IdNamePair";

export interface IPeopleLookupProps {
    onPersonSelected: (id: IdNamePair) => void;
}

export interface IPeopleLookupState {
    searchString: string;
    results: ItemSearchModel[] | undefined;
    isSearching: boolean;
}

export type PeopleLookupProps = IPeopleLookupProps & IAuthContextProps & ISnackbarContextProps;

class PeopleLookup extends React.Component<PeopleLookupProps, IPeopleLookupState> {
    constructor(props: PeopleLookupProps) {
        super(props);
        this.state = {
            searchString: "",
            results: undefined,
            isSearching: false
        }
    }
    private onSearchStringChanged = (e: any) => {
        this.setState({ searchString: e.target.value });
    }
    private onPerformSearch = async (e: any) => {
        this.setState({ isSearching: true });
        try {
            const results = await this.props.callApi(f => PeopleRequestFactory.search(f, this.state.searchString));
            this.setState({ isSearching: false, results: results });
        } catch (e) {
            this.props.showSnackbarMessage(`Failed to perform search: ${e}`);
            this.setState({ isSearching: false, results: undefined });
        }
    }
    private onSelect = (e: any) => {
        if (this.state.results) {
            const id = e.currentTarget.getAttribute("data-person-id");
            const match = this.state.results.filter(r => r.documentId == id)[0];
            if (match) {
                this.props.onPersonSelected({ id: match.documentId, name: match.title });
            }
        }
    }
    render(): JSX.Element {
        const { results, isSearching } = this.state;
        const endAdornment = <InputAdornment position="end">
            <IconButton aria-label="Search" onClick={this.onPerformSearch}>
                <Search />
            </IconButton>
        </InputAdornment>
        return <div>
            <FormControl>
                <InputLabel htmlFor="people-search-input">Search</InputLabel>
                <Input fullWidth={true} id="people-search-input" value={this.state.searchString} onChange={this.onSearchStringChanged} endAdornment={endAdornment} />
            </FormControl>
            {(() => {
                if (results) {
                    return <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell numeric>ID</TableCell>
                                <TableCell numeric>Name</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {results.map(n => {
                                return (
                                    <TableRow key={n.documentId}>
                                        <TableCell numeric component="th" scope="row">
                                            {n.documentId}
                                        </TableCell>
                                        <TableCell>{n.title}</TableCell>
                                        <TableCell><Button variant="contained" color="primary" onClick={this.onSelect} data-person-id={n.documentId}>Select</Button></TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>;
                } else if (isSearching) {
                    return <LinearProgress />;
                }
                return undefined;
            })()}
        </div>
    }
}

export default withAuthContext(withSnackbar(PeopleLookup));


// WEBPACK FOOTER //
// ./src/components/people-lookup.tsx